import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { localFetcher } from '@/api/fetcher';
import { URLS } from '@/constants/api';
import { QUERY_KEYS } from '@/constants/queryKeys';
import type { GcssData } from '@/app/api/gcss-data/types';
export function useGcssData() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: QUERY_KEYS.gcssData(),
      queryFn: _temp,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      retry: 1,
      retryDelay: 1000
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
}
async function _temp(t0) {
  const {
    signal
  } = t0;
  const res = await localFetcher(URLS.gcssData, {
    signal
  });
  return res.json;
}